import type { PropsWithChildren } from 'react';
import React from 'react';

export default function Overlay({
  opened,
  onClick,
  children,
}: PropsWithChildren<{ opened?: boolean; onClick?: () => void }>) {
  const childrenRef = React.useRef<HTMLDivElement>(null);

  const handleClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    if (e.target instanceof Node && childrenRef.current?.contains(e.target)) {
      return;
    }

    onClick?.();
  };

  if (!opened) {
    return null;
  }

  return (
    <div
      role="presentation"
      className="pointer-events-auto fixed inset-0 z-[10000] flex items-center justify-center bg-[rgb(0_0_0_/_40%)]"
      onClick={handleClick}
    >
      <div ref={childrenRef}>{children}</div>
    </div>
  );
}
